<script setup>
import snakeCase from 'lodash-es/snakeCase';
import { GA } from '@/mixins/Ga';

const ga = new GA({ category: 'bioCta', action: 'clicInterne' });

defineProps({
    parentURI: {
        type: String,
        default: '',
    },
    items: { type: Array, default: () => [] },
    type: {
        type: String,
        default: '',
    },
});

const snakeUri = (per, title) => `/${per}#${snakeCase(title)}`;
</script>

<template>
    <ul class="BioCtaSubnav mb-24 mt-6 flex flex-col flex-wrap md:mb-0 md:flex-row">
        <li
            v-for="section in items"
            :key="section.title"
            class="py-0 md:mr-6"
        >
            <router-link
                class="hover-line relative inline-block text-sm"
                :to="snakeUri(parentURI, section.title)"
            >
                <span v-on:click="ga.send({ label: 'decouvrir' + section.title })">{{ section.title }}</span>
            </router-link>
        </li>
    </ul>
</template>
